import React, { Component } from 'react';
import _ from 'lodash';
import Modal from './modals';
import moment from 'moment';

class ShootsOverviewRow extends Component {
	constructor() {
		super();
		this.state = {
			showEventModal: false,
			startDate: null,
			endDate: null,
		};
	}

	getFilteredList = (data, month) => {
		let tot = 0;
		// console.log('countttttttttttt', data.length, month);
		for (let i = 0; i < data.length; i++) {
			if (moment(data[i].date, 'YYYYMMDD').format('YYYY-MM') === month) {
				tot += data[i].count;
			}
		}
		return tot;
	};
	render() {
		return (
			<tr>
				<td className="all-other-column-fixed">
					<div className="project-general-box">
						<span className="crew-outer-container">
							{moment(this.props.month, 'YYYY-MM').format("MMM 'YY")}
						</span>
					</div>
				</td>
				<td className="all-other-column-fixed">
					<div className="project-general-box text-center">
						<span className="crew-outer-container text-center">
							{this.getFilteredList(this.props.data, this.props.month)}
						</span>
					</div>
				</td>
				{[...Array(31)].map((e, i) => (
					<td
						className="all-other-column-fixed"
						style={{
							backgroundColor:
								moment().format('YYYYMMDD') ===
								moment(
									this.props.month + `-${i + 1 < 10 ? `0${i + 1}` : i + 1}`,
									'YYYY-MM-DD',
								).format('YYYYMMDD')
									? `#5f55ec`
									: _.size(
											_.filter(this.props.data, {
												date: parseInt(
													moment(
														this.props.month +
															`-${i + 1 < 10 ? `0${i + 1}` : i + 1}`,
														'YYYY-MM-DD',
													).format('YYYYMMDD'),
												),
											}),
									  ) > 0
									? `rgba(173, 0, 255, ${parseFloat(
											_.filter(this.props.data, {
												date: parseInt(
													moment(
														this.props.month +
															`-${i + 1 < 10 ? `0${i + 1}` : i + 1}`,
														'YYYY-MM-DD',
													).format('YYYYMMDD'),
												),
											})[0].count / this.props.maxCount,
									  ).toFixed(2)})`
									: '',
						}}
					>
						<div className="project-general-box text-center">
							<span
								className="crew-outer-container text-center"
								onClick={() => {
									this.props.onDayClick(this.props.month, i);
								}}
							>
								{i + 1 >
								parseInt(
									moment(this.props.month, 'YYYY-MM').endOf('month').format('DD'),
								) ? (
									'X'
								) : (
									<>
										{_.size(
											_.filter(this.props.data, {
												date: parseInt(
													moment(
														this.props.month +
															`-${i + 1 < 10 ? `0${i + 1}` : i + 1}`,
														'YYYY-MM-DD',
													).format('YYYYMMDD'),
												),
											}),
										) > 0
											? _.filter(this.props.data, {
													date: parseInt(
														moment(
															this.props.month +
																`-${
																	i + 1 < 10 ? `0${i + 1}` : i + 1
																}`,
															'YYYY-MM-DD',
														).format('YYYYMMDD'),
													),
											  })[0].count
											: '\u00b7'}
									</>
								)}
							</span>
						</div>
					</td>
				))}
			</tr>
		);
	}
}

export default ShootsOverviewRow;
